import { DataTable } from 'primereact/datatable';
import Heading from '../../../../components/Heading/Heading';
import styles from '../../css/User.module.css';
import { useEffect, useState } from 'react';
import {
	generateApprovedUserRoleDetails,
	generateApprovedUserRoles,
	removeApprovedUserRole,
} from '../../../../utils/common.utils';
import CONSTANTS from '../../../../constants';
import { Column } from 'primereact/column';
import Icon from '../../../../components/Icon/Icon';
import { Tooltip } from 'primereact/tooltip';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import {
	getMonthFormatDate,
	getTimestamp,
} from '../../../../utils/getDate.utils';
import ViewUserData from '../../Users/List Users/ViewUserData';
import CreateUserRole from '../Create User Role/CreateUserRole';

const ListUserRole = () => {
	const [approvedUserRoles, setApprovedUserRoles] = useState([]);
	const [userRoleDetails, setUserRoleDetails] = useState({});

	useEffect(() => {
		generateApprovedUserRoles(setApprovedUserRoles);
	}, []);

	// console.log(approvedUserRoles);
	// Active Approved User Roles
	const activeApprovedUserRoles = approvedUserRoles.filter(
		(userObj) => userObj.active === 'Y'
	);

	const handleGetUserRoleDetails = (rowData) => {
		generateApprovedUserRoleDetails(
			rowData.roleName,
			setUserRoleDetails,
			approvedUserRoles,
			setApprovedUserRoles
		);
	};

	const handleDeleteApprovedUserRole = (rowData) => {
		removeApprovedUserRole(rowData.roleName);
	};

	const handleEditApprovedUserRole = (rowData) => {
		//Get user role obj and change edit visibility
		const newUserRoleList = approvedUserRoles.map((obj) => {
			if (obj.roleName === rowData.roleName) {
				const newUserRoleObj = { ...obj, visibleEditable: true };
				return newUserRoleObj;
			}
			return obj;
		});
		// console.log(newUserRoleList);
		//Set new user role list to re-render the rowData
		setApprovedUserRoles(newUserRoleList);
	};

	const handleShowPermission = (rowData) => {
		//Get user role obj and change visibility
		const newUserRoleList = approvedUserRoles.map((obj) => {
			if (obj.roleName === rowData.roleName) {
				const newUserRoleObj = { ...obj, visiblePermission: true };
				return newUserRoleObj;
			}
			return obj;
		});
		// console.log(newUserRoleList);
		//Set new user role list to re-render the rowData
		setApprovedUserRoles(newUserRoleList);
	};

	// console.log(activeApprovedUserRoles);

	const creationDateTemplate = (field) => {
		const convertedTimestamp = getTimestamp(field.creationDate);
		const date = getMonthFormatDate(convertedTimestamp?.split(' ')[0]);
		const time = convertedTimestamp?.split(' ')[1];
		const ampm = convertedTimestamp?.split(' ')[2];
		return <span>{`${date} ${time} ${ampm}`}</span>;
	};

	const actionBodyTemplate = (rowData) => {
		// console.log(rowData);
		const roleName = rowData.roleName;
		const isEditAllowed = !(roleName === 'admin' || roleName === 'channel');
		return (
			<div className={styles['actions__container']}>
				{isEditAllowed && (
					<Icon
						icon="edit"
						tooltip="Create an edit request"
						className={`${styles['actions-icon']} ${styles['table-icon']} edit`}
						onClick={() => handleEditApprovedUserRole(rowData)}
					/>
				)}
				<Tooltip target=".edit" position="top" className={styles.tooltip} />
				<Dialog
					header="Edit user role"
					visible={rowData.visibleEditable}
					maximizable
					onHide={() => {
						//Get user role obj and change visibility
						const newUserRoleList = approvedUserRoles.map((obj) => {
							if (obj.roleName === rowData.roleName) {
								const newUserRoleObj = { ...obj, visibleEditable: false };
								return newUserRoleObj;
							}
							return obj;
						});
						// console.log(newUserRoleList);
						//Set new user role list to re-render the rowData
						setApprovedUserRoles(newUserRoleList);
					}}
				>
					<CreateUserRole isEditable roleName={rowData.roleName} />
				</Dialog>
				{isEditAllowed && (
					<Icon
						icon="delete"
						tooltip="Create a delete request"
						className={`${styles['actions-icon']} ${styles['table-icon']} delete `}
						onClick={() => handleDeleteApprovedUserRole(rowData)}
					/>
				)}
				<Tooltip target=".delete" position="top" className={styles.tooltip} />
				<Button
					className={styles['action-button']}
					onClick={() => handleGetUserRoleDetails(rowData)}
				>
					View Details
				</Button>
				<Dialog
					header="User Role Details"
					visible={rowData.visible}
					onHide={() => {
						//Change one single object
						const updatedUserRoleDetails = {
							...userRoleDetails,
							visible: false,
						};
						setUserRoleDetails(updatedUserRoleDetails);
						//Change array of objects to maintain state
						const updatedApprovedUserRoleList = approvedUserRoles.map(
							(userObj) =>
								userObj.roleName === rowData.roleName
									? updatedUserRoleDetails
									: userObj
						);
						setApprovedUserRoles(updatedApprovedUserRoleList);
					}}
				>
					<ViewUserData userData={userRoleDetails} isRoleData />
				</Dialog>
			</div>
		);
	};

	const permissionTemplate = (rowData) => {
		return (
			<div>
				<Button
					onClick={() => handleShowPermission(rowData)}
					className={styles['action-button']}
				>
					Click to view
				</Button>
				<Dialog
					header={`Role permissions (${rowData.permissionGroupList?.length})`}
					visible={rowData.visiblePermission}
					onHide={() => {
						//Get user role obj and change visibility
						const newUserRoleList = approvedUserRoles.map((obj) => {
							if (obj.roleName === rowData.roleName) {
								const newUserRoleObj = { ...obj, visiblePermission: false };
								return newUserRoleObj;
							}
							return obj;
						});
						// console.log(newUserRoleList);
						//Set new user role list to re-render the rowData
						setApprovedUserRoles(newUserRoleList);
					}}
				>
					<div className={styles['permission-group__container']}>
						{rowData.permissionGroupList?.map((permission) => (
							<div key={permission}>{permission}</div>
						))}
					</div>
				</Dialog>
			</div>
		);
	};

	return (
		<div className="main">
			<Heading>List of approved user roles</Heading>
			<div className={styles['user__container']}>
				<div className={styles['table__container']}>
					<DataTable
						value={activeApprovedUserRoles}
						paginator
						rows={10}
						rowsPerPageOptions={[5, 10, 15, 20, 30, 50]}
						emptyMessage="No approved user roles found."
						removableSort
					>
						{CONSTANTS.userRoleColumns.map((col) => (
							<Column
								key={col.field}
								field={col.field}
								header={col.header}
								sortable
								className={styles['wrap-text']}
							/>
						))}
						<Column
							body={permissionTemplate}
							field="permissionGroupList"
							header="Permissions"
						></Column>
						<Column
							body={creationDateTemplate}
							field="creationDate"
							header="Creation Date"
							sortable
						></Column>
						<Column
							body={actionBodyTemplate}
							field="actions"
							header="User Actions"
						></Column>
					</DataTable>
				</div>
			</div>
		</div>
	);
};

export default ListUserRole;
